<template>
    <template v-if="!msg">
        <div class="grid">
            <div class="unit whole">
                <h2>Message not found</h2>
            </div>
        </div>
    </template>

    <template v-else>
        <div class="grid">
            <div class="unit whole">
                <h1>Messages</h1>
                <p v-if="msg.to_teacher" class="lead">Messages to me.</p>
                <p v-else class="lead">Messages from {{ pupilName(msg.pupil) }}.</p>
            </div>
        </div>
        <div class="grid">
            <div class="unit whole">
                <div class="panel">
                    <h2>Message</h2>
                    <template v-if="msg?.to_teacher">
                        <p><strong>From:</strong> {{ pupilName(msg.pupil) }}</p>
                        <p><strong>To:</strong> me</p>
                    </template>
                    <template v-else>
                        <p><strong>From:</strong> me</p>
                        <p><strong>To:</strong> {{ pupilName(msg.pupil) }}</p>
                    </template>
                    <p><strong>Sent:</strong> {{ formatDateTime(msg.sent) }}</p>
                    <template v-if="msg.context === 'Reply from teacher'">
                        <p><strong>Subject:</strong> Reply from teacher</p>
                    </template>
                    <template v-else>
                        <p><strong>Subject:</strong> {{ msg.context }}</p>
                    </template>
                    <p>
                        <strong>Message:</strong>
                    </p>
                    <p>{{ msg.message }}</p>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="unit whole">
                <div class="panel">
                    <h2 v-if="!msg.to_teacher">Send another message to {{ pupilName(msg.pupil) }}</h2>
                    <h2 v-else>Send a reply to {{ pupilName(msg.pupil) }}</h2>
                    <form @submit.stop.prevent="sendMessage">
                        <div><v-textarea v-model="newMessage" name="newmessage" required /></div>
                        <div>
                            <v-btn type="submit" color="primary">Send</v-btn>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </template>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'messages' } });
const route = useRoute('/teacher/message/[[message_id]');
const router = useRouter();
const { formatDateTime } = useDateFormat();
const store = useTeacherStore();
store.fetchMessages();
store.fetchTeacher();
store.fetchPupils();
const { messages, teacher } = storeToRefs(store);
const { pupilName } = store;

const msg = computed(() => {
    const messageId = parseInt(route.params.message_id + '');
    return messages.value?.find((m) => m.id === messageId);
});

watchEffect(() => {
    if (msg.value && msg.value.to_teacher && !msg.value.msg_read) {
        store.markMessageRead(msg.value.id);
    }
});

const newMessage = ref('');

async function sendMessage() {
    if (!msg.value) {
        return;
    }
    await store.createMessage({
        pupil: { uid: msg.value.pupil.uid },
        teacher: { uid: teacher.value!.uid },
        message: newMessage.value,
        context: 'Reply from teacher',
        to_teacher: false,
    });
    await router.push('/teacher/messages');
}
</script>
